import { UI_ACTION_TYPES } from 'utils/actions/ui'

const defaultState = {
  dialogOpen: false,
  dialogId: '',
  statusUpdate: '',
  selectedTab: {},
  selectedTabIndex: 2,
}

export const uiReducer = (state = defaultState, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case UI_ACTION_TYPES.TAB_CLICK: {
      return {
        ...state,
        ...payload,
      }
    }
    case UI_ACTION_TYPES.OPEN_DIALOG: {
      return {
        ...state,
        dialogData: payload,
        dialogId: payload.id,
        statusUpdate: payload.statusUpdate,
        dialogOpen: true,
      }
    }
    case UI_ACTION_TYPES.CLOSE_DIALOG: {
      return {
        ...state,
        dialogId: '',
        statusUpdate: '',
        dialogOpen: false,
      }
    }
    default:
      return state
  }
}

export default uiReducer
